import { render, staticRenderFns } from "./read_original.vue?vue&type=template&id=42e9a314&scoped=true"
import script from "./read_original.vue?vue&type=script&lang=js"
export * from "./read_original.vue?vue&type=script&lang=js"
import style0 from "./read_original.vue?vue&type=style&index=0&id=42e9a314&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e9a314",
  null
  
)

export default component.exports